import { Fragment, memo } from 'react';
import EditData from '../../shared/edit-data';
import CivilStatus from '../../shared/civil-status';
import CivilUnion from './civil-union';
import AccordionPerson from 'shell/components/shared/person';

const FormRegistrationCivilUnionComponent = (): React.ReactElement => {
  return (
    <Fragment>
      <AccordionPerson disabled />
      <EditData />
      <CivilStatus />
      <CivilUnion />
    </Fragment>
  );
};

FormRegistrationCivilUnionComponent.displayName = 'Registration CivilUnion component';

const FormRegistrationCivilUnion = memo(FormRegistrationCivilUnionComponent);

export default FormRegistrationCivilUnion;
